(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Search results for',
    result: 'result',
    results: 'results',
    noCollectionFound: 'No collection found',
    allProducts: 'See all products',
    matching: 'matching',
    sortBy: 'Sort by',
    sortByAndFilter: 'Sort by & filter',
    relevance: 'Relevance',
    resultsFound: 'results found',
    oneResultFound: '1 result found',
    noResultFound: 'No result found',
    searchResultsFor: 'Search results for',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    filtersTitle: 'Filters',
    selectedFilter: 'Selected filters',
    removeFilters: 'Remove',
    applyFilters: 'Apply Filters',
    clearAll: 'Clear all',
    noPageFound: 'No page found',
    product: 'product',
    products: 'products',
    showing: 'Showing',
    outOf: 'of',
    loadPrevious: 'Load previous',
    loadMore: 'Load more',
    badges: {
      sold_out: "Sold out",
      discount: 'Save',
      sustainable: 'Sustainable',
      new: 'New',
      bundle_and_save: 'Bundle and save',
      bestseller: 'Bestseller',
      back_in_stock: 'Back in stock',
    },
    quickAdd: 'Quick Add',
    outOfStock: 'Out of stock',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for query ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      var nrOfShownHits = Math.min((this.page + 1) * this.hitsPerPage, this.nbHits);
      return `${algolia.translations.showing} ${nrOfShownHits} ${algolia.translations.outOf} `;
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
